import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import {PracticeModel} from "../../models/accounts/practice.model";

@Injectable({
  providedIn: 'root'
})
export class PracticeChangeService {
  private practiceChangeSubject = new Subject<PracticeModel>();
  practiceChange$ = this.practiceChangeSubject.asObservable();

  changePractice(selectedPractice: PracticeModel) {
    this.practiceChangeSubject.next(selectedPractice);
  }
}
